(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["furrytales-product"] && !Shopify.designMode) return;
  try {
    
  class FurryTalesProduct extends HTMLElement {
    connectedCallback() {
      this.variants = this.readJson('[data-ft-variants]', []);
      this.moneyFormat = this.readJson('[data-ft-money-format]', '');
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-ft-variant-id]');
      this.price = this.querySelector('[data-ft-price]');
      this.comparePrice = this.querySelector('[data-ft-compare-price]');
      this.submitButtons = this.querySelectorAll('[data-ft-submit], [data-ft-sticky-submit]');
      this.stickyPrice = this.querySelector('[data-ft-sticky-price]');
      this.stickyVariant = this.querySelector('[data-ft-sticky-variant]');
      this.optionGroups = [...this.querySelectorAll('[data-ft-option]')];
      this.bindGallery();
      this.bindOptions();
      this.bindQuantity();
    }

    readJson(selector, fallback) {
      const node = this.querySelector(selector);
      if (!node) return fallback;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return fallback;
      }
    }

    bindGallery() {
      this.querySelectorAll('[data-ft-media-button]').forEach((button) => {
        button.addEventListener('click', () => this.showMedia(button.dataset.ftMediaButton));
      });
    }

    bindOptions() {
      this.optionGroups.forEach((group) => {
        group.addEventListener('change', () => this.onOptionChange());
      });
    }

    bindQuantity() {
      const input = this.querySelector('.ft-quantity__input');
      const minus = this.querySelector('[data-ft-quantity-minus]');
      const plus = this.querySelector('[data-ft-quantity-plus]');
      if (!input) return;
      if (minus) {
        minus.addEventListener('click', () => {
          const nextValue = Math.max(1, Number(input.value || 1) - 1);
          input.value = String(nextValue);
        });
      }
      if (plus) {
        plus.addEventListener('click', () => {
          const nextValue = Math.max(1, Number(input.value || 1) + 1);
          input.value = String(nextValue);
        });
      }
    }

    onOptionChange() {
      const selectedOptions = this.optionGroups.map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      const variant = this.variants.find((item) => {
        return item.options.every((option, index) => option === selectedOptions[index]);
      });
      if (!variant) return;
      this.updateVariant(variant);
    }

    updateVariant(variant) {
      if (this.variantInput) this.variantInput.value = variant.id;
      this.updateSelectedLabels(variant);
      this.updatePrice(variant);
      this.updateButtons(variant);
      if (variant.featured_media && variant.featured_media.id) {
        this.showMedia(String(variant.featured_media.id));
      }
    }

    updateSelectedLabels(variant) {
      this.optionGroups.forEach((group, index) => {
        const label = this.querySelector(`[data-ft-selected-option="${index + 1}"]`);
        if (label) label.textContent = variant.options[index] || '';
      });
      if (this.stickyVariant) this.stickyVariant.textContent = variant.public_title || '';
    }

    updatePrice(variant) {
      const priceText = this.formatMoney(variant.price);
      if (this.price) this.price.textContent = priceText;
      if (this.stickyPrice) this.stickyPrice.textContent = priceText;
      if (!this.comparePrice) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.comparePrice.textContent = this.formatMoney(variant.compare_at_price);
        this.comparePrice.classList.remove('is-hidden');
      } else {
        this.comparePrice.textContent = '';
        this.comparePrice.classList.add('is-hidden');
      }
    }

    updateButtons(variant) {
      this.submitButtons.forEach((button) => {
        button.disabled = !variant.available;
        const addLabel = button.dataset.addLabel || button.dataset.ftAddLabel || 'Add to cart';
        const soldOutLabel = button.dataset.soldOutLabel || button.dataset.ftSoldOutLabel || 'Sold out';
        button.textContent = variant.available ? addLabel : soldOutLabel;
      });
    }

    showMedia(mediaId) {
      const update = () => {
        this.querySelectorAll('[data-ft-media]').forEach((item) => {
          const active = item.dataset.ftMedia === mediaId;
          item.toggleAttribute('hidden', !active);
          item.classList.toggle('is-active', active);
        });
        this.querySelectorAll('[data-ft-media-button]').forEach((button) => {
          const active = button.dataset.ftMediaButton === mediaId;
          button.classList.toggle('is-active', active);
          if (active) button.setAttribute('aria-current', 'true');
          if (!active) button.removeAttribute('aria-current');
        });
      };
      if (document.startViewTransition) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, this.moneyFormat);
      }
      const currency = this.dataset.currency || 'EUR';
      return (Number(cents) / 100).toLocaleString(undefined, { style: 'currency', currency });
    }
  }

  if (!customElements.get('furrytales-product')) {
    customElements.define('furrytales-product', FurryTalesProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
